export const auth_routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("../Main.vue")
  },
  {
    path: "/recover-pass/:token",
    props: true,
    name: "Recuperação de Senha",
    component: () => import("../ForgotPasswordFire.vue")
  },
  {
    path: "/activate-account/:id",
    props: true,
    name: "Ative sua conta",
    component: () => import("../ActivateAccount.vue")
  },
  {
    path: "/:sponsor_id",
    props: true,
    name: "Cadastro",
    component: () => import("../components/FormSignup")
  }
];

export default {};
